import { render, staticRenderFns } from "./DashboardRootView.vue?vue&type=template&id=7634f990"
import script from "./DashboardRootView.vue?vue&type=script&lang=js"
export * from "./DashboardRootView.vue?vue&type=script&lang=js"
import style0 from "./DashboardRootView.vue?vue&type=style&index=0&id=7634f990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports